import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import Card from '@material-ui/core/Card';
// import CardActionArea from '@material-ui/core/CardActionArea';
// import CardActions from '@material-ui/core/CardActions';
// import CardContent from '@material-ui/core/CardContent';
// import CardMedia from '@material-ui/core/CardMedia';
// import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import notfound from '../assets/notfound.png';
// import img2 from '../assets/download.jpeg';
// import img3 from '../assets/olmec.jpg';
// import img4 from '../assets/Our-Work_Project-Portfolio_J-Paul-Leonard-and-Sutro-Libraries_Hero-Image-1280x582.jpg';
import Grid from '@material-ui/core/Grid';
// import img5 from '../assets/photo-1524995997946-a1c2e315a42f.jpeg';
// import { Toolbar } from "@material-ui/core";
import ButtonBase from '@material-ui/core/ButtonBase';
import Paper from '@material-ui/core/Paper';
// import Divider from '@material-ui/core/Divider';
import { connect } from "react-redux";
import { compose } from "redux";
import { fetchPublicLibraries } from "../actions/LibraryAction"
import { ATTACHMENT_END_POINT } from "../helpers/constants";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';
import Phone from "@material-ui/icons/Phone";
const { innerWidth } = window;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        margin: 'auto',
    },
    image: {
        // width: '90%',
        // height: '80%',
        height: innerWidth <= 480 ? 100 : 250,
        width: '100%'
    },
    img: {
        height: innerWidth <= 480 ? 100 : 250,
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%'
    },
    grow: {
        flexGrow: 1,
    },
    fontOptions: {
        lineHeight: 1.8,
    },
    centerText: {
        textAlign: 'center'
    },
    headerTextColor: {
        color: '#1E1759',
        fontWeight: 'bold',
        lineHeight: 1.8,
    },
    paragraphTextColor: {
        color: '#888',
        fontWeight: 300,
        fontSize: 15
    },
    gradientButton: {
        // background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)'
        // background: '#6128be'
        // background: '#86C42B'
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },
    table: {
        // minWidth: 700,
    },
    row: {
        height: 30
    },
    cell: {
        padding: '4px 50px 4px 0px',
        border: 'none'
    },
    chip: {
        margin: 0,
        textTransform: 'none',
        height: 20,
        fontSize: 11
    },
});

const CustomTableCell = withStyles(theme => ({
    head: {
        //backgroundColor: theme.palette.common.black,
        color: "#2926ac",
        fontWeight: "bold",
        fontSize: 13
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

class Library extends Component {
    componentDidMount() {
        this.props.dispatch(fetchPublicLibraries())
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Grid container spacing={24}>
                    <Grid item xs={12} className={classes.centerText}>
                        <Typography variant="h4" className={`${classes.grow} ${classes.headerTextColor}`}>
                            California Libraries
                        </Typography>
                    </Grid>
                    <Grid container spacing={8}>
                        {this.props.publicLibraries.map(row => (
                            <Grid item xs={12} key={row.id}>
                                <Paper className={classes.paper}>
                                    <Grid container spacing={16}>
                                        <Grid item xs={6}>
                                            <ButtonBase className={classes.image}>
                                                <img src={row.attachments.length > 0 ? `${ATTACHMENT_END_POINT}${row.attachments[0].file_name}` : notfound} className={classes.img} alt="Logo" />
                                            </ButtonBase>
                                        </Grid>
                                        <Grid item xs={12} sm container>
                                            <Grid item xs container direction="column" spacing={16}>
                                                <Grid item xs>
                                                    <Typography gutterBottom variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                                        {row.library_name}
                                                    </Typography>
                                                    <Typography gutterBottom style={{ marginBottom: 15 }}>{row.library_email}</Typography>
                                                    {row.library_phone !== "" && row.library_phone !== null && row.library_phone !== "null" && row.library_phone !== "undefind" && 
                                                    <Typography gutterBottom style={{ marginBottom: 15 }}><Phone style={{ fontSize: 16, marginRight: 5,marginBottom:-3 }}/> { row.library_phone}</Typography>
                                                    }
                                                    <Table className={classes.table}>
                                                        <TableBody>
                                                            {
                                                                row.bookingTimeSlots.length > 0
                                                                    ? row.bookingTimeSlots.map(slot => (
                                                                        slot.status === "ACTIVE"
                                                                            ?
                                                                            <TableRow className={classes.row} key={slot.id}>
                                                                                <CustomTableCell className={classes.cell}>{slot.day_of_week}</CustomTableCell>
                                                                                <CustomTableCell className={classes.cell}>{moment(slot.start_time, "hh:mm:ss").format('LT')} - {moment(slot.end_time, "hh:mm:ss").format('LT')}</CustomTableCell>
                                                                            </TableRow>
                                                                            :
                                                                            <TableRow className={classes.row} key={slot.id}>
                                                                                <CustomTableCell className={classes.cell}>{slot.day_of_week}</CustomTableCell>
                                                                                <CustomTableCell className={classes.cell}>
                                                                                    <Chip label={slot.status} className={classes.chip} color="secondary" variant="outlined" />
                                                                                </CustomTableCell>
                                                                            </TableRow>
                                                                    ))
                                                                    :

                                                                    <TableRow className={classes.row} key={`${row.id}_${0}`} >
                                                                        {/* <CustomTableCell colSpan={2} className={classes.cell} >{``}</CustomTableCell> */}
                                                                        <CustomTableCell colSpan={2} className={classes.cell} >{`Please contact`} <span style={{fontWeight:"bold"}}> {row.user.email} </span> {`for schedule and session.`} </CustomTableCell>

                                                                    </TableRow>
                                                            }

                                                        </TableBody>
                                                    </Table>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

Library.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        publicLibraries: state.LibraryReducer.publicLibraries
    }
}
export default compose(withStyles(styles), connect(mapStateToProps))(Library);







